import { Divider, Input, Select } from 'antd'
import React from 'react'
import {CloseCircleFilled} from "@ant-design/icons";
import { useSelector } from 'react-redux';
export default function InvitationForm({index, onRemove, data, onChangeFunc}) {
  // console.log(data.fName)
  const state = useSelector(state=>state.manageUsers);
  const userTypeList = state.userTypeList.filter(usr=>{
    usr.value=usr.id;
    usr.label=usr.typeName;
    usr.name =usr.typeName
    return usr;
  })
  return (
    <>
    {index === 0 &&<Divider style={{marginBlock:'10px'}}/>}
    <div style={{display:'flex', justifyContent:'start', alignItems:'center'}}>
        <div style={{width:'16%', textAlign:'start'}}><Input type="text" placeholder='First name' value={data.firstName} onChange={(e)=>onChangeFunc(index, e.target.value,'first')} style={{width:'90%'}}/></div>
        <div style={{width:'16%', textAlign:'start'}}><Input type='text' placeholder='Last name' value={data.lastName} onChange={(e)=>onChangeFunc(index, e.target.value,'last')} style={{width:'90%'}}/></div>
        <div style={{width:'22%', textAlign:'start'}}><Input type='email' placeholder='Write your email' value={data.email} style={{width:'90%'}} onChange={(e)=>onChangeFunc(index, e.target.value,'email')} /></div>
        <div style={{width:'18%', textAlign:'start'}}><Select mode='multiple' options={state.roleList} placeholder="Assign Role" value={data.roles} style={{width:'90%'}} onChange={(e)=>onChangeFunc(index, e,'role')}/></div>
        <div style={{width:'18%', textAlign:'start'}}><Select options={userTypeList} placeholder="Select User Type" value={data.userType} onChange={(e)=>onChangeFunc(index, e,'usertype')} style={{width:'90%'}}/></div>
        <div style={{width:'5%', textAlign:'start'}}>{index !== 0 &&<i className='fa fa-times-circle' style={{width:'100%', fontSize:'20px', cursor:'pointer'}} onClick={()=>onRemove(index)}></i>}</div>
    </div>
    <Divider style={{marginBlock:'10px'}}/>
    </>
  )
}
